import React from 'react';

import BasePagination from 'components/Shared/Pagination';

import { useLimitFilter, usePageFilter } from 'lib/hooks/useSrpFilters';

export interface PaginationProps {
  resultsCount: number;
  onPageChange: (page: number) => void;
}

export default function Pagination(props: PaginationProps): JSX.Element | null {
  const pageFilter = usePageFilter();
  const limitFilter = useLimitFilter();

  const handlePageChange = (page: number): void => {
    pageFilter.setValue(page);
    props.onPageChange(page);
  };

  if (pageFilter.value === undefined) {
    return null;
  }

  return (
    <BasePagination
      currentPage={pageFilter.value}
      pageSize={limitFilter.value}
      totalResults={props.resultsCount}
      onPageChange={handlePageChange}
    />
  );
}
